<template>
  <div>
    <div class="cards-totales-grid" v-for="(row, rowIndex) in agruparRegistros" :key="'row-' + rowIndex">
      <div class="card-total" v-for="(item, index) in row" :key="'payment-' + rowIndex + '-' + index">
        <div>
          <span class="card-total-nombre">{{ item.nombre }}</span>
          <span class="card-total-valor">
            <span v-if="typeof item.total === 'number'">
              {{ formatoMonto(item.total) }}
            </span>
            <span v-else>
              {{ item.total }}
            </span>
          </span>
        </div>
        <div class="card-total-icon">
          <b-icon :icon="item.icono" size="is-large" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utiles from '../../Servicios/Utiles'

export default {
  name: "CartasTotalesFiltradas",
  props: ["registros"],
  computed: {
    agruparRegistros ()
    {
      const chunkSize = 3;
      const chunks = [];
      for (let i = 0; i < this.registros.length; i += chunkSize) {
        chunks.push(this.registros.slice(i, i + chunkSize));
      }
      return chunks;
    }
  },
  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    }
  }
}
</script>